import {  useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Icons from "../../myIcon/Icons";
import { clearAuthSession } from "../../helper/AuthSession";
import { usePermissions } from "../../helper/PermissionContext";

const MENU = {
  userManagement: "user-management",
  dashboard: "dashboard",
  blogManagement: "blog-management",
  projectManagement: "project-management",
  productManagement: "product-management",
  newsManagement: "news-management",
  dynamicPage: "dynamic-page",
  seoManagement: "seo-management",
  sitemap: "sitemap",
  globalSeo: "global-seo",
  llmsManagement: "llms-management",
  robotsManagement: "robots-management",
  emailManagement: "email-management",
  faqManagement: "faq-management",
  contactUs: "contact-us",
  career: "career",
};

export default function SideBar({ isOpen, toggleSidebar }) {
  const [isUserManagementOpen, setIsUserManagementOpen] = useState(false);
  const [isBlogManagementOpen, setIsBlogManagementOpen] = useState(false);
  const [isProjectManagementOpen, setIsProjectManagementOpen] = useState(false);
  const [isProductManagementOpen, setIsProductManagementOpen] = useState(false);
  const { hasPermission } = usePermissions();

  const navigate = useNavigate();

  const toggleUserManagement = () => setIsUserManagementOpen((prev) => !prev);
  const toggleBlogManagement = () => setIsBlogManagementOpen((prev) => !prev);
  const toggleProjectManagement = () => setIsProjectManagementOpen((prev) => !prev);
  const toggleProductManagement = () => setIsProductManagementOpen((prev) => !prev);


  const handleLogout = () => {
    clearAuthSession();
    navigate("/login");
  };

  return (
    <>
      <div className={`admin-logo-wrap ${isOpen ? "close" : "open"}`}>
        <img src="/assets/logo.webp" alt="logo" className="img-responsive" />
        <button className="toggle-button" onClick={toggleSidebar}>
          ☰
        </button>
      </div>
      <div className={`admin-sidebar ${isOpen ? "close" : "open"}`}>        
        <div className="scroller-sidebar">
          <ul style={isOpen
                ? { transition: "all 0.3s ease-in", opacity: "0", visibility :"hidden" }
                : { transition: "all 0.3s ease-in", opacity: "1", visibility :"visible"}}>

            {hasPermission(MENU.dashboard) && (
              <li>
                <Link to="/"><span><img src="/assets/dashboard.webp" alt="icon" className="img-responsive" />Dashboard</span></Link>
              </li>
            )}

            {hasPermission(MENU.userManagement) && (
              <li className={`innertab ${isUserManagementOpen ? "openlist" : ""}`} onClick={toggleUserManagement}>
                <div><span><img src="/assets/dashboard.webp" alt="icon" className="img-responsive" /> User Management</span> <Icons name="arrowDown" /></div>
                <ul className={`nested-list ${isUserManagementOpen ? "open" : "close"}`}>
                  <li><Link to="users">Users</Link></li>
                  <li><Link to="roles">Roles</Link></li>
                  <li><Link to="permissions">Permissions</Link></li>
                </ul>
              </li>
            )}

            {hasPermission(MENU.blogManagement) && (
            <li className={`innertab ${isBlogManagementOpen ? "openlist" : ""}`} onClick={toggleBlogManagement}>
              <div><span><img src="/assets/blog-management.webp" alt="icon" className="img-responsive" /> Blog Management</span> <Icons name="arrowDown" /></div>
              <ul className={`nested-list ${isBlogManagementOpen ? "open" : "close"}`}>
                <li><Link to="category">Category</Link></li>
                <li>
                  <Link to="author"><span>Author</span></Link>
                </li>
                <li><Link to="blog">Blog</Link></li>
                {/* <li><Link to="tag">Tag</Link></li> */}
              </ul>
            </li>
            )}

            {hasPermission(MENU.projectManagement) && (
            <li className={`innertab ${isProjectManagementOpen ? "openlist" : ""}`} onClick={toggleProjectManagement}>
              <div><span><img src="/assets/project-management.webp" alt="icon" className="img-responsive" /> Project Management</span> <Icons name="arrowDown" /></div>
              <ul className={`nested-list ${isProjectManagementOpen ? "open" : "close"}`}>
                <li><Link to="project">Project</Link></li>
                <li><Link to="project-category">Project Type</Link></li>
              </ul>
            </li>
            )}

            {hasPermission(MENU.productManagement) && (
            <li className={`innertab ${isProductManagementOpen ? "openlist" : ""}`} onClick={toggleProductManagement}>
              <div><span><img src="/assets/product-management.webp" alt="icon" className="img-responsive" /> Product Management</span> <Icons name="arrowDown" /></div>
              <ul className={`nested-list ${isProductManagementOpen ? "open" : "close"}`}>
                <li><Link to="product">Product</Link></li>
                <li><Link to="product-category">Category</Link></li>
              </ul>
            </li>
            )}

            {hasPermission(MENU.newsManagement) && (
            <li>
              <Link to="news"><span><img src="/assets/news-icon.webp" alt="icon" className="img-responsive" /> News Management</span></Link>
            </li>
            )}


            {hasPermission(MENU.dynamicPage) && (
             <li>
              <Link to="dynamic"><span><img src="/assets/news-icon.webp" alt="icon" className="img-responsive" /> Dynamic Page</span></Link>
            </li>
            )}

            {hasPermission(MENU.seoManagement) && (
            <li>
              <Link to={"seo"}><span><img src="/assets/seo-management.webp" alt="icon" className="img-responsive" /> SEO Management</span></Link>
            </li>
            )}

            {hasPermission(MENU.sitemap) && (
            <li>
              <Link to={"sitemap"}><span><img src="/assets/seo-management.webp" alt="icon" className="img-responsive" /> Sitemap</span></Link>
            </li>
            )}

            {hasPermission(MENU.globalSeo) && (
            <li>
              <Link to={"global-seo"}><span><img src="/assets/seo-management.webp" alt="icon" className="img-responsive" /> Global SEO</span></Link>
            </li>
            )}

            {hasPermission(MENU.llmsManagement) && (
            <li>
              <Link to={"llms"}><span><img src="/assets/seo-management.webp" alt="icon" className="img-responsive" /> LLMS Management</span></Link>
            </li>
            )}

            {hasPermission(MENU.robotsManagement) && (
            <li>
              <Link to={"robots"}><span><img src="/assets/seo-management.webp" alt="icon" className="img-responsive" /> Robots.txt Management</span></Link>
            </li>
            )}

            {hasPermission(MENU.emailManagement) && (
            <li>
              <Link to={"email-management"}><span><img src="/assets/newsletter.webp" alt="icon" className="img-responsive" /> Email Management</span></Link>
            </li>
            )}

            {hasPermission(MENU.faqManagement) && (
            <li>
              <Link to={"faq"}><span><img src="/assets/news-icon.webp" alt="icon" className="img-responsive" /> FAQ Management</span></Link>
            </li>
            )}

            {hasPermission(MENU.contactUs) && (
            <li>
              <Link to={"contact"}><span><img src="/assets/contact-management.webp" alt="icon" className="img-responsive" /> Contact Us</span></Link>
            </li>
            )}

            {hasPermission(MENU.career) && (
            <li>
              <Link to={"career"}><span><img src="/assets/career-icon.webp" alt="icon" className="img-responsive" /> Career</span></Link>
            </li>
            )}
          </ul>
        </div>
          
        <button onClick={handleLogout} className="default-btn logout-button">Logout<span></span></button>
      </div>
    </>
  );
}
